export default "__VITE_ASSET__9df95887__"